'use strict';

/**
 * Margiela Revamp override of core/components/wishlist.js
 *
 * Stripped of all Marni / JilSander / private-sales branches — this file only ever runs on
 * Margiela Revamp storefronts. Cart badge refresh now goes through Revamp's cart.js
 * ('cart:refreshCart' custom event) instead of the classic minicart DOM/event system, and the
 * wishlist row is live-refreshed on variant change via updateWishlistRow(), which replaces the
 * old populateTile() (that function assumed classic grid-tile markup that doesn't exist here).
 */

const addToCartValidation = require('../product/addToCartValidation');

/**
 * NOTE: Re-enable this code feature and adjust the scss
 * (by moving the desktop view properties to the default file)
 * if you want the CTA row on mobile to behave responsively by rising below
 * the details column or dropping to a second row.
 * ----------------------------------------------------------------------------------------------
 * Measures whether each row's .mm-wishlist-item__actions content (Remove + the current
 * add-to-cart/notify-me button label) overflows its default width — the content column, next to
 * the image — and if so switches it to span the full card width instead
 * matching wishlistProductCard.isml's CSS Grid (see _wishlist.default.scss).
 * Text length varies per locale (translated button labels) and per state (add-to-cart vs
 * notify-me have different lengths), so this can't be decided server-side — it has to be measured
 * against the actual rendered width.
 * @param {HTMLElement} [scope] - only rows within this element are re-measured; defaults to the
 *   whole document (initial load / window resize).
 */
function adjustWishlistActionsLayout(scope) {
  const root = scope || document;
  const rows = [...root.querySelectorAll('.mm-wishlist-item__actions')];
  rows.forEach((row) => {
    row.classList.remove('-full-width');
    var removeCTA = row.querySelector('.remove-from-wishlist');
    var buttonsContainer = row.querySelector('.add-to-cart-switch');
    if ((removeCTA.clientWidth + buttonsContainer.clientWidth) >= row.clientWidth) {
      row.classList.add('-full-width');
    }
  });
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 * @param {string} action - button that was clicked to add a product to the wishlist
 */
/**
 * Stato del bottone wishlist: classe E etichette insieme.
 * aria-label/title non possono venire dal markup, perche' Tile-Show e' cachata 24h e
 * condivisa per gruppo promo (personalized = setVaryBy('price_promotion')): un valore
 * per-cliente li' dentro e' sbagliato per qualcuno. Il markup nasce neutro e i testi
 * localizzati arrivano da data-label-add / data-label-remove.
 * @param {jQuery} $button - il bottone
 * @param {boolean} isActive - true se il prodotto e' in wishlist
 */
function setWishlistState($button, isActive) {
  $button.toggleClass('active', isActive);

  const labelAdd = $button.attr('data-label-add');
  const labelRemove = $button.attr('data-label-remove');
  if (!labelAdd || !labelRemove) return;

  const label = isActive ? labelRemove : labelAdd;
  $button.attr('aria-label', label);
  $button.find('.add-to-wish-list-icon').attr('title', label);
}

function handleResponse(data, button, action = 'add') {
  $.spinner().stop();

  if (data.success) {
    showAriaHint(button, data.msg, action);

    const modalpid = data.pid || button.data('pid');

    if (action === 'remove') {
      setWishlistState(button, false);
      if (modalpid) {
        setWishlistState($('.js_add-to-wish-list[data-pid="' + modalpid + '"]'), false);
      }
    } else {
      setWishlistState(button, true);
      if (modalpid) {
        setWishlistState($('.js_add-to-wish-list[data-pid="' + modalpid + '"]'), true);
      }

      $('.js_add-to-wish-list-cart[data-pid="' + modalpid + '"]').addClass('active');
      $('body').trigger('product:afterAddToWishlist', this);
    }

    if (action !== 'remove') {
      // Revamp notification popup event
      const popupEvt = new CustomEvent('MMPopup:open', {
        detail: {
          id: 'add-to-wishlist-popup-' + window.brandCategory.toLowerCase()
        }
      });
      document.dispatchEvent(popupEvt);
    }

    var listIsEmpty = data.quantityTotal === 0;
    updateHeaderWishlistIcon(listIsEmpty);

    // If we're currently ON the wishlist landing page (e.g. this add/remove came from a heart
    // button inside an overlay on top of it, like the cart sheet's "Save to wishlist"), the row
    // list underneath is now stale — refresh it the same way bindRemoveFromWishlist() does for
    // its own remove button.
    if ($('.wishlistItemCardsData').length) {
      const currentPageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
      renderNewPageOfItems(currentPageNumber, false);
    }
  }

  setTimeout(function () {
    button.removeClass('disabled-click');
    button.attr('tabindex', 0);
  }, 5000);
}

/**
 * Toggles the header wishlist button between its empty/filled icon state. Both
 * components/navigation/header/mm/right-block.isml and .../mm6/right-block.isml render BOTH
 * icons up front (.empty / .not-empty classes) on the same `.btn-header-wishlist` button;
 * `_header.md-min.scss` shows/hides them via CSS keyed on the button's own `.empty-wishlist`
 * class, so this only ever needs to toggle that one class — no brand check needed.
 * @param {boolean} isEmpty - true when the wishlist has 0 items
 */
function updateHeaderWishlistIcon(isEmpty) {
  const button = document.querySelector('.js-header-wishlist');
  if (!button) return;

  button.classList.toggle('empty-wishlist', isEmpty);
}

/**
 * Sets the header wishlist icon's correct state on every page load — handleResponse() /
 * bindRemoveFromWishlist() only update it in reaction to an add/remove happening in the CURRENT
 * session; a customer who already has saved items and simply navigates to a new page needs this
 * fetched from the server instead (the button starts in the "empty" state server-side by default,
 * see right-block.isml).
 */
function initHeaderWishlistIcon() {
  const button = document.querySelector('.js-header-wishlist');
  const url = button && button.getAttribute('data-wishlist-size-url');
  if (!url) return;

  $.ajax({
    url: url,
    method: 'GET',
    success: function (data) {
      updateHeaderWishlistIcon(!data || !data.size);
    },
  });
}

/**
 * Riallinea lo stato `.active` dei bottoni asterisco alla wishlist reale del cliente.
 * Serve perche' la tile e' cachata 24h con `product.inWishList` dentro il markup
 * (applyPromotionSensitiveCache su Tile-Show): il valore cachato e' per definizione
 * sbagliato per qualcuno, in entrambe le direzioni, e va riparato lato client.
 */
function getCustomerWishlist() {
  const button = document.querySelector('.js-header-wishlist');
  const url = button && button.getAttribute('data-customer-wishlist-products');
  if (!url) return;

  $.ajax({
    url: url,
    method: 'GET',
    success: function (responseData) {
      if (!responseData) return;

      $('.js_add-to-wish-list.active').each(function () {
        setWishlistState($(this), false);
      });
      if (responseData.wishlistIDS && responseData.wishlistIDS.length > 0) {
        responseData.wishlistIDS.forEach(function (item) {
          $('.js_add-to-wish-list[data-pid=' + item + ']').each(function () {
            setWishlistState($(this), true);
          });
        });
      }
    },
  });
}

function showAriaHint(button, message, action) {
  const modalpid = button.data('pid');
  const allButtons = modalpid ? $('.js_add-to-wish-list[data-pid="' + modalpid + '"]') : button;

  allButtons.each(function () {
    const $btn = $(this);
    let nonvisualHint = $btn.next('.visually-hidden');
    $(nonvisualHint).text(message);
    if (action === 'add') {
      $btn.attr('aria-pressed', 'true');
    } else {
      $btn.attr('aria-pressed', 'false');
    }
  });
}

function showErrorMessage(form, message) {
  const $row = $(form).closest('.mm-wishlist-item');
  $row.find('.js-wishlist__error').html(message);
  const button = $row.find('.add-to-cart');
  button.addClass('disabled');
  button.prop('disabled', true);
}

function hideErrorMessage(form) {
  const $row = $(form).closest('.mm-wishlist-item');
  $row.find('.js-wishlist__error').html('');
  const button = $row.find('.add-to-cart');
  button.removeClass('disabled');
  button.prop('disabled', false);
}

function addToCartFromWishlist(form, e) {
  const globalAddToCartURL = document.querySelector('input[name="global-add-to-cart-url"]');
  const pidInput = form.getAttribute('data-pid');

  hideErrorMessage(form);
  if (globalAddToCartURL && pidInput) {
    // .add-to-cart is a sibling of <form>, not a descendant (see wishlistProductCard.isml) — look
    // it up from the row.
    const row = form.closest('.mm-wishlist-item');
    const btnAddToCart = row ? row.querySelector('.add-to-cart') : null;
    if (btnAddToCart) {
      btnAddToCart.setAttribute('disabled', true);
    }
    $.ajax({
      url: globalAddToCartURL.value,
      method: 'POST',
      data: {
        quantity: 1,
        pid: pidInput,
      },
      success: function (responseData) {
        if (btnAddToCart) {
          btnAddToCart.removeAttribute('disabled');
        }
        if (!responseData.error) {
          $('body').trigger('product:afterAddToCart', responseData); // eslint-disable-line no-undef

            const updateCartBagdeEvt = new CustomEvent('cart:updateCartBadge', {
                detail: {
                    itemsCount: responseData.cart.numItems
                }
            });
            // Update cart icon number
            document.dispatchEvent(updateCartBagdeEvt);

            const openCartEvt = new CustomEvent('cart:openCart');
            // Open cart sheet
            document.dispatchEvent(openCartEvt);

          if ($('.cart-page').length > 0) {
            location.reload();
          }
        } else {
          showErrorMessage(form, responseData.message);
        }

        $.spinner().stop();
      },
      error: function () {
        if (btnAddToCart) {
          btnAddToCart.removeAttribute('disabled');
        }
        $.spinner().stop();
      },
    });
  }
}

/**
 * Live-refreshes a wishlist row after a variant attribute (color/size) change, using the
 * ProductFactory/Tile-Show product model returned by Product-Variation — the same model/shape
 * wishlist/components/wishlistProductCard.isml already consumes server-side.
 * @param {Object} product - product model returned by the Product-Variation ajax call
 * @param {HTMLElement} targetForm - the row's <form name="add-to-cart-from-wishlist">
 */
function updateWishlistRow(product, targetForm) {
  const row = targetForm.closest('.mm-wishlist-item');
  if (!row) return;

  // Image — mirrors the swipeableImages -> mouseoverImages -> tileImageUrl fallback in
  // wishlist/components/wishlistProductCard.isml
  let wishlistImage;
  if (product.swipeableImages && product.swipeableImages.large && product.swipeableImages.large.length > 0) {
    wishlistImage = product.swipeableImages.large[0];
  } else if (product.mouseoverImages && product.mouseoverImages.large && product.mouseoverImages.large.length > 0) {
    wishlistImage = product.mouseoverImages.large[0];
  }

  const image = row.querySelector('.mm-wishlist-item__image');
  if (image) {
    if (wishlistImage) {
      image.setAttribute('src', wishlistImage.dis ? wishlistImage.dis['512'] : wishlistImage.url);
      image.setAttribute('alt', wishlistImage.alt || product.productNameForTile);
      image.setAttribute('title', wishlistImage.title || '');
    } else if (product.tileImageUrl) {
      image.setAttribute('src', product.tileImageUrl);
      image.setAttribute('alt', product.tileImageAlt || product.productNameForTile);
    }
  }

  // Price — product.price.html is rendered server-side (Product.js Variation route) through the
  // same product/components/pricing/main partial the row's initial render already uses
  if (product.price && product.price.html) {
    const priceEl = row.querySelector('.mm-wishlist-item__price');
    if (priceEl) {
      priceEl.innerHTML = product.price.html;
    }
  }

  // Variation attributes — rebuild <select> options for multi-value attributes, or update the
  // static value text for single-value attributes, mirroring the isif/iselseif split in
  // wishlistProductCard.isml
  if (product.variationAttributes) {
    product.variationAttributes.forEach((attr) => {
      const select = row.querySelector('.select-' + attr.id);

      if (select) {
        select.innerHTML = '';
        attr.values.forEach((value) => {
          const option = document.createElement('option');
          option.value = value.value;
          option.setAttribute('data-attr-value', value.value);
          option.textContent = value.displayValue;
          if (!value.selectable) {
            option.setAttribute('data-icon', 'mm-bell');
          }
          option.selected = !!value.selected;
          select.appendChild(option);
        });
        // Rebuilds the MMSelect custom dropdown from the native select's current options
        select.dispatchEvent(new CustomEvent('MMSelect:refresh'));
      } else if (attr.values && attr.values.length === 1) {
        const staticValue = row.querySelector('.attribute-' + attr.id + ' .mm-wishlist-item__variant-value');
        if (staticValue) {
          staticValue.textContent = attr.values[0].displayValue;
        }
        // Keep the hidden dwvar_ field (added so single-value attributes still get serialized
        // with the form — see wishlistProductCard.isml) in sync too.
        const staticInput = row.querySelector('.attribute-' + attr.id + ' input[name="dwvar_' + product.masterID + '_' + attr.id + '"]');
        if (staticInput) {
          staticInput.value = attr.values[0].value;
          staticInput.setAttribute('data-attr-value', attr.values[0].value);
        }
      }
    });
  }

  // Availability
  const addToCartBtn = row.querySelector('.add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.disabled = !product.available;
    if (product.available) {
      addToCartBtn.removeAttribute('aria-disabled');
    } else {
      addToCartBtn.setAttribute('aria-disabled', 'true');
    }
  }

  // Add to Cart / Notify Me switch — mirrors wishlistProductCard.isml's initial-render condition
  // on .add-to-cart-switch: `hasSelectedValue && (product.showBackInStockNotification || !product.available)`.
  // product.isOrderable is NOT usable here — it's a master/attribute-level check ("does at least
  // one value exist per attribute"), not whether the specific combination just selected is
  // available, so it never flips to notify-me for an unavailable size. hasSelectedValue is
  // implicitly true here — this only runs after a variant was just resolved via a select change.
  const addToCartSwitch = row.querySelector('.add-to-cart-switch');
  if (addToCartSwitch) {
    addToCartSwitch.classList.toggle('show-notify-me', !!(product.showBackInStockNotification || !product.available));
    row.classList.toggle('-notify-me', !!(product.showBackInStockNotification || !product.available));
  }

  // Notify Me trigger's data-notifyme-url is baked with the INITIAL product.id at server render
  // time (wishlistProductCard.isml) and never touched again — after a variant change it kept
  // pointing at the original variant, so opening the sheet always showed the base product's form
  // instead of the one just selected. Re-point it at the newly resolved product.id.
  const notifyTrigger = row.querySelector('.js-wishlist-notify-me-trigger');
  if (notifyTrigger) {
    const notifyUrl = notifyTrigger.getAttribute('data-notifyme-url');
    if (notifyUrl) {
      const url = new URL(notifyUrl, window.location.origin);
      url.searchParams.set('pid', product.id);
      notifyTrigger.setAttribute('data-notifyme-url', url.pathname + url.search);
    }
  }

  // Add-to-cart and notify-me labels have different lengths — re-measure whether the actions row
  // still fits narrow now that the switch above may have changed which button is shown.
  //adjustWishlistActionsLayout(row);
}

function bindAddToCart() {
  const wishlistItemAttributeSelect = [...document.querySelectorAll('.wishlist__select')];
  wishlistItemAttributeSelect.forEach((select) => {
    select.addEventListener('change', wishlistSelectChange);
  });

  const addToCartForm = [...document.querySelectorAll('form[name="add-to-cart-from-wishlist"]')];
  addToCartForm.forEach((form) => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (addToCartValidation($(form))) {
        addToCartFromWishlist(form, e);
      }
    });
  });
}

function wishlistSelectChange(e) {
  const target = e.currentTarget;
  const parentForm = target.form;
  $(e.target).parent().removeClass('invalid');
  hideErrorMessage(parentForm);

  if($(e.target).parent().siblings('.js-error_msg').length > 0) {
      $(e.target).parent().siblings('.js-error_msg').text('');
  }

  if (parentForm.checkValidity()) {
    $.ajax({
      url: parentForm.getAttribute('action'),
      method: 'GET',
      data: $(parentForm).serialize(),
      beforeSend: () => {
        $.spinner().start();
      },
      success: function (responseData) {
        target.dispatchEvent(new Event('blur'));
        parentForm.setAttribute('data-pid', responseData.product.id);
        parentForm.querySelector('input[name="ean"]').value = responseData.product.id;
        updateWishlistRow(responseData.product, parentForm);
        $.spinner().stop();
      },
      error: function () {
        $.spinner().stop();
      },
    });
  }
}


/**
 * Single shared "Notify Me" sheet (wishlist/components/wishlistNotifyMeSheet.isml) — clicking any
 * row's trigger fetches THAT row's product notify-me form and injects it into the shared
 * container. MMTriggerComponent (data-component on the same button) handles opening the sheet;
 * this only handles filling its content, same split responsibility as cart.js's edit-cart-sheet.
 *
 * NOTE: bound directly on each trigger, NOT delegated via $('body').on(...) — BaseComponent.$on()
 * (used by MMTriggerComponent, which lives on this same button) calls e.stopPropagation() before
 * its own callback, so the click never bubbles up to a body-level delegated listener. Other
 * listeners on the SAME element are unaffected by stopPropagation, so binding here directly still
 * fires regardless of registration order relative to MMTriggerComponent's own listener.
 */
function bindNotifyMeTrigger() {
  const triggers = [...document.querySelectorAll('.js-wishlist-notify-me-trigger')];
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const url = trigger.getAttribute('data-notifyme-url');
      const container = document.querySelector('.wishlist-notify-me-sheet_container');
      if (!url || !container) return;

      $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
          container.innerHTML = data && data.notifyWhenAvailableHtml ? data.notifyWhenAvailableHtml : '';
        },
      });
    });
  });
}

/**
 * @param {Object} $elementAppendTo - The element to append error html to
 * @param {string} msg - The error message
 * display error message if remove item from wishlist failed
 */
function displayErrorMessage($elementAppendTo, msg) {
  if ($('.remove-from-wishlist-messages').length === 0) {
    $elementAppendTo.append('<div class="remove-from-wishlist-messages "></div>');
  }

  $('.remove-from-wishlist-messages').append(
    '<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>'
  );

  setTimeout(function () {
    $('.remove-from-wishlist-messages').remove();
  }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 */
function renderNewPageOfItems(pageNumber, spinner) {
  const publicView = $('.wishlistItemCardsData').data('public-view');
  const listUUID = $('.wishlistItemCardsData').data('uuid');
  const url = $('.wishlistItemCardsData').data('href');
  const account = $('.wishlistItemCardsData').data('account');

  if (spinner) {
    $.spinner().start();
  }

  const scrollPosition = document.documentElement.scrollTop;
  let newPageNumber = pageNumber;
  $.ajax({
    url: url,
    method: 'get',
    data: {
      pageNumber: ++newPageNumber,
      publicView: publicView,
      id: listUUID,
      account: account,
    },
  })
    .done(function (data) {
      $('.wishlistItemCards').empty();
      $('body .wishlistItemCards').replaceWith(data);
      bindAddToCart();
      // Re-bind directly (not delegated, see bindNotifyMeTrigger's own note) on the freshly
      // rendered rows — the DOM-change observer re-inits data-component elements (MMTriggerComponent)
      // automatically, but this listener is plain addEventListener, not dispatcher-managed.
      bindNotifyMeTrigger();
      //adjustWishlistActionsLayout();
      document.documentElement.scrollTop = scrollPosition;
      if (document.querySelector('.mm-video-card:not(.observed)')) {
        $('body').trigger('wishlist:update-plp-cards');
      }
    })
    .fail(function () {
      $('.more-wl-items').remove();
    });
  $.spinner().stop();
}

function bindRemoveFromWishlist() {
  $('body').on('click', '.remove-from-wishlist', function (e) {
    e.preventDefault();
    const url = $(this).data('url');
    const elMyAccount = $('.account-wishlist-item').length;

    // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
    if (elMyAccount > 0) {
      $('.wishlist-account-card').spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'html',
        data: {},
        success: function (html) {
          $('.wishlist-account-card>.card').remove();
          $('.wishlist-account-card').append(html);
          bindAddToCart();
          $('.wishlist-account-card').spinner().stop();
        },
        error: function () {
          const $elToAppend = $('.wishlist-account-card');
          $elToAppend.spinner().stop();
          const msg = $elToAppend.data('error-msg');
          displayErrorMessage($elToAppend, msg);
        },
      });
      // else user is in wishlist landing page, call removeProduct() end point, then remove this card
    } else {
      $.spinner().start();
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {},
        success: function (data) {
          var listIsEmpty = data.quantityTotal === 0;
          updateHeaderWishlistIcon(listIsEmpty);
          const pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
          renderNewPageOfItems(pageNumber, false);
        },
        error: function () {
          $.spinner().stop();
          const $elToAppendWL = $('.wishlistItemCards');
          const msg = $elToAppendWL.data('error-msg');
          displayErrorMessage($elToAppendWL, msg);
        },
      });
    }
  });
}

module.exports = {
  addToCartFromWishlist: () => {
    bindAddToCart();
  },
  headerWishlistIcon: function () {
    initHeaderWishlistIcon();
  },
  customerWishlistState: function () {
    // main.js chiama processInclude dentro $(document).ready, quindi qui siamo gia' pronti
    getCustomerWishlist();
  },
  /*wishlistActionsLayout: function () {
    if (!document.querySelector('.mm-wishlist-item__actions')) return;

    adjustWishlistActionsLayout();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => adjustWishlistActionsLayout(), 150);
    });
  },*/
  bindCartRecommendations: function () {
    $('body').on('click', '.mm-button.cart-lineitem-recommendation', function (e) {
      var selector = '.' + e.currentTarget.dataset.actionPid;
      if ($(selector)[0].classList.contains('visually-hidden')) {
        $(selector)[0].classList.remove('visually-hidden');
      } else {
        $(selector)[0].classList.add('visually-hidden');
      }
      bindAddToCart();
    });
  },
  addToWishlist: function () {
    $(document).on('click', '.js_add-to-wish-list', function (e) {
      e.preventDefault();
      const $button = $(this);
      const shouldValidate = $button.data('validateProduct');
      let url = $button.data('add');
      let action = 'add';

      if ($button.hasClass('active')) {
        url = $button.data('remove');
        action = 'remove';
      }

      let $productContainer = $button.closest('.set-item');

      if (!$productContainer.length) {
        $productContainer = $button.closest('.product-detail');
      }

      if ($(this).parent().hasClass('sticky-button') && shouldValidate && addToCartValidation($productContainer) === false) {
        $('html, body').animate(
          {
            scrollTop: $('#sticky-error-scroll-to').offset().top,
          },
          300
        );
      }

      if (shouldValidate && addToCartValidation($productContainer) === false) return;

      let pid = e.currentTarget.dataset.pid;

      // // Check if the product is a shop the look item
      // let isShopTheLookProduct = $button.closest('.product-detail').hasClass('stl-product-wrapper');

      // // Check if the product is a recommender item
      // let isShopTheLookRecommendation = $button.closest('.recommendations-tile').hasClass('stl-recommendation');

      // if (isShopTheLookRecommendation) {
      //   pid = $button.closest('.recommendations-tile').find('.product').data('pid');
      // } else if (isShopTheLookProduct) {
      //   pid = $button.data('pid');
      // } else if ($button.closest('#editWishlistProductModal').length > 0) {
      //   pid = base.getPidValue($(this));
      // } else if ($button.closest('#editProductModal').length > 0) {
      //   pid = this.dataset.pid;
      // } else if ($button.closest('.product-detail').find('.add-to-cart').length > 0 && $button.closest('.product-detail').find('.add-to-cart').attr('data-pid')) {
      //   pid = $button.closest('.product-detail').find('.add-to-cart').attr('data-pid');
      // } else {
      //   pid = $button.data('pid');
      // }

      let optionId = $button.closest('.product-detail').find('.product-option').attr('data-option-id');
      let optionVal = $button.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
      optionId = optionId || null;
      optionVal = optionVal || null;

      if (!url || !pid) {
        return;
      }

      $.spinner().start();
      $button.addClass('disabled-click');
      $button.attr({ 'tabindex': -1, 'aria-pressed': true });

      setTimeout(() => {
        $.ajax({
          url: url,
          type: 'post',
          dataType: 'json',
          data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal,
          },
          success: function (data) {
            handleResponse(data, $button, action);
            if ($('#edit-product-modal.is-open').length > 0) {
              $('#edit-product-modal.is-open .add-to-wish-list-icon')[0].innerHTML = data.label;
              $('#edit-product-modal.is-open .add-to-wish-list-icon')[1].innerHTML = data.label;
            }
          },
          error: function (err) {
            handleResponse(err, $button, action);
          },
        });
      }, 0);
    });

    $(document).on('click', '.js_add-to-wish-list-cart', function (e) {
      e.preventDefault();
      const $button = $(this);

      if ($button.hasClass('active')) {
        return;
      }

      const url = $button.data('href');
      const pid = $button.data('pid');

      if (!url || !pid) {
        return;
      }

      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
          pid: pid,
        },
        success: function (data) {
          $button.addClass('active');
          handleResponse(data, $button);
        },
        error: function (err) {
          handleResponse(err, $button);
        },
      });
    });
  },
  addToWishlistCloseNotification: function () {
    $(document).on('click', '.wishlist-popup-icon .close-button', function (e) {
      $('.wishlist-popup').removeClass('is-open');
    });
  },
  addToWishlistNotificationRevert: function () {
    $(document).on('click', '.wishlist-popup-removed .wishlist-popup-icon span', function (e) {
      $('.wishlist-popup').removeClass('is-open');
      $('.js_add-to-wish-list').click();
    });
  },
  removeFromWishlist: function () {
    bindRemoveFromWishlist();
  },
  notifyMe: function () {
    bindNotifyMeTrigger();
  },
  addAllToCart: function () {
    $('body').on('click', '.js_add-all-to-cart', function () {
      $('body').trigger('product:beforeAddToCart', this);
      const addToCartUrl = document.querySelector('input[name="global-add-to-cart-url"]')
        ? document.querySelector('input[name="global-add-to-cart-url"]').value
        : null;
      const pidsObj = [];
      [
        ...document.querySelectorAll(
          '.wishlistItemCards .product-grid-container .product-tile__actions form[name="add-to-cart-from-wishlist"]'
        ),
      ].forEach((item) => {
        if (addToCartValidation($(item))) {
          if (item.querySelector('input[name="ean"]') && !item.classList.contains('private-sales-product')) {
            const pid = item.querySelector('input[name="ean"]').value;
            pidsObj.push({
              pid: pid,
              qty: 1,
            });
          }
        }
      });

      if (addToCartUrl && pidsObj.length > 0) {
        const form = {
          pidsObj: JSON.stringify(pidsObj),
        };

        $.ajax({
          url: addToCartUrl,
          method: 'POST',
          data: form,
          beforeSend: () => {
            $.spinner().start();
          },
          success: function (data) {
            let currentQty = 0;
            $('.js-quantity.quantity.counter').each(function (i, e) {
              currentQty = parseInt($(e).text());
            });
            if (data.quantityTotal > currentQty) {
              // Tealium event "Cart Add Full List"
              data.addAllProductsFromWishList = true;
              $('body').trigger('product:afterAddToCart', data);
              $('.minicart-action').trigger('click');
              $('.js-quantity.quantity.counter').text(data.quantityTotal);
            }

            $.spinner().stop();
          },
          complete: function () {
            $.spinner().stop();
          },
        });
      }
    });
  },
};
